import { Component, OnInit } from '@angular/core';
import { MembershipApiService } from '../commons/services/api/membership/membership-api.service';

@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.scss']
})
export class MembershipComponent implements OnInit {
  showResult = false;
  disableButton = false;
  errors: string[] = [];

  customerCI: string;
  customerName: string;
  points: number;
  constructor(
    private _membershipApiService: MembershipApiService
  ) { }

  ngOnInit(): void {
  }

  searchPoints() {
  this.errors = [];

    if (!this.customerCI || this.customerCI.trim() === '') {
      this.errors.push('El número de carnet es requerido.');
      return;
    }

    if (!/^\d+$/.test(this.customerCI)) {
      this.errors.push('El número de carnet no es válido.');
      return;
    }

    this.disableButton = true;

    this._membershipApiService.searchPoints(this.customerCI).subscribe({
      next: (response) => {
        this.customerName = response.result.customerName;
        this.points = response.result.points;
        this.showResult = true;
        this.errors = [];
      },
      error: (error) => {
        this.disableButton = false;
        this.showResult = false;
        for (let i = 0; i < error.error.errorList.length; i++) {
          this.errors.push(error.error.errorList[i].message);
        }
      }
    })

  }

  toCamelCase(text: string): string {
    return text
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase());
  }

}
